// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page401__wrapper__1K0Rx","btnWrapper":"page401__btnWrapper__3cX6j"};